// extracted by mini-css-extract-plugin
var _1 = "iYcyvg";
var _2 = "asR8k5";
export { _1 as "layout", _2 as "main" }
